<body class="hold-transition login-page">
  <app-toastr></app-toastr>

  <div class="login-box" >
    <div class="login-logo">
      <svg width="93" height="38" viewBox="0 0 62 25" ><title>nexedu</title><path d="M3.1,9.5c0.4-0.1,1-0.2,1.7-0.3C5.4,9,6.1,8.9,6.9,8.9c0.8,0,1.4,0.1,1.9,0.3c0.5,0.2,0.9,0.5,1.2,0.8 c0.3,0.4,0.5,0.8,0.6,1.3c0.1,0.5,0.2,1,0.2,1.7v5H8.2v-4.7c0-0.8-0.1-1.4-0.3-1.7c-0.2-0.3-0.6-0.5-1.2-0.5c-0.2,0-0.4,0-0.6,0 c-0.2,0-0.4,0-0.5,0.1V18H3.1V9.5z M12.6,13.7c0-0.8,0.1-1.5,0.4-2.1c0.2-0.6,0.6-1.1,1-1.5c0.4-0.4,0.8-0.7,1.4-0.9c0.5-0.2,1-0.3,1.6-0.3 c1.3,0,2.3,0.4,3,1.2c0.7,0.8,1.1,1.9,1.1,3.4c0,0.1,0,0.3,0,0.5c0,0.2,0,0.3,0,0.5h-5.7c0.1,0.5,0.3,0.9,0.7,1.2 c0.4,0.3,1,0.5,1.7,0.5c0.5,0,0.9,0,1.4-0.1c0.4-0.1,0.8-0.2,1.1-0.3l0.3,2c-0.1,0.1-0.3,0.1-0.5,0.2c-0.2,0.1-0.5,0.1-0.8,0.2 s-0.6,0.1-0.9,0.1c-0.3,0-0.6,0.1-0.9,0.1c-0.8,0-1.5-0.1-2.1-0.4c-0.6-0.2-1.1-0.6-1.5-1c-0.4-0.4-0.7-0.9-0.9-1.5 C12.7,14.9,12.6,14.3,12.6,13.7z M18.5,12.7c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.2-0.4-0.3-0.5c-0.1-0.2-0.3-0.3-0.5-0.4 C17.4,11,17.2,11,16.9,11c-0.3,0-0.5,0-0.7,0.1c-0.2,0.1-0.4,0.2-0.5,0.4c-0.1,0.2-0.2,0.3-0.3,0.5c-0.1,0.2-0.1,0.4-0.2,0.6H18.5 z M26.4,11.6l1.8-2.5h2.6l-3.1,4.3c0.7,0.8,1.3,1.6,1.9,2.4c0.5,0.8,1,1.5,1.3,2.1h-2.7 c-0.1-0.2-0.2-0.4-0.3-0.6c-0.1-0.3-0.3-0.5-0.5-0.8c-0.2-0.3-0.3-0.5-0.5-0.7c-0.2-0.2-0.4-0.4-0.5-0.5c-0.2,0.1-0.3,0.3-0.5,0.5 c-0.2,0.2-0.3,0.4-0.5,0.7c-0.2,0.3-0.3,0.5-0.5,0.8c-0.2,0.3-0.3,0.5-0.4,0.7h-2.6c0.1-0.3,0.3-0.6,0.6-1 c0.2-0.4,0.5-0.8,0.8-1.2c0.3-0.4,0.6-0.8,0.9-1.2c0.3-0.4,0.6-0.7,0.9-1.1c-0.6-0.8-1.1-1.5-1.6-2.3c-0.5-0.7-1-1.4-1.5-2.1h2.7 L26.4,11.6z M31.4,13.7c0-0.8,0.1-1.5,0.4-2.1c0.2-0.6,0.6-1.1,1-1.5c0.4-0.4,0.8-0.7,1.4-0.9c0.5-0.2,1-0.3,1.6-0.3 c1.3,0,2.3,0.4,3,1.2c0.7,0.8,1.1,1.9,1.1,3.4c0,0.1,0,0.3,0,0.5s0,0.3,0,0.5H34c0.1,0.5,0.3,0.9,0.7,1.2c0.4,0.3,1,0.5,1.7,0.5 c0.5,0,0.9,0,1.4-0.1c0.4-0.1,0.8-0.2,1.1-0.3l0.3,2c-0.1,0.1-0.3,0.1-0.5,0.2c-0.2,0.1-0.5,0.1-0.8,0.2c-0.3,0.1-0.6,0.1-0.9,0.1 c-0.3,0-0.6,0.1-0.9,0.1c-0.8,0-1.5-0.1-2.1-0.4c-0.6-0.2-1.1-0.6-1.5-1c-0.4-0.4-0.7-0.9-0.9-1.5C31.5,14.9,31.4,14.3,31.4,13.7z  M37.3,12.7c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.2-0.4-0.3-0.5c-0.1-0.2-0.3-0.3-0.5-0.4S36,11,35.7,11c-0.3,0-0.5,0-0.7,0.1 c-0.2,0.1-0.4,0.2-0.5,0.4c-0.1,0.2-0.2,0.3-0.3,0.5c-0.1,0.2-0.1,0.4-0.2,0.6H37.3z M49.5,17.7c-0.2,0.1-0.5,0.1-0.8,0.2c-0.3,0.1-0.6,0.1-0.9,0.2c-0.3,0-0.6,0.1-1,0.1c-0.3,0-0.6,0-1,0 c-0.7,0-1.4-0.1-2-0.3c-0.6-0.2-1.1-0.5-1.5-0.9c-0.4-0.4-0.7-0.9-0.9-1.5c-0.2-0.6-0.3-1.2-0.3-1.9c0-0.7,0.1-1.4,0.3-1.9 c0.2-0.6,0.4-1.1,0.8-1.5c0.3-0.4,0.8-0.7,1.2-0.9C44,9.1,44.6,9,45.2,9c0.3,0,0.7,0,0.9,0.1c0.3,0.1,0.6,0.2,0.8,0.3v-4l2.5-0.4 V17.7z M43.8,13.5c0,0.8,0.2,1.4,0.5,1.9c0.3,0.5,0.9,0.7,1.6,0.7c0.2,0,0.4,0,0.6,0c0.2,0,0.3,0,0.5-0.1v-4.6 c-0.2-0.1-0.4-0.2-0.6-0.3c-0.3-0.1-0.5-0.1-0.8-0.1C44.4,11.1,43.8,11.9,43.8,13.5z M59.5,17.7c-0.4,0.1-1,0.2-1.7,0.3c-0.7,0.1-1.4,0.2-2.1,0.2c-0.8,0-1.4-0.1-1.9-0.3 c-0.5-0.2-0.9-0.5-1.2-0.9c-0.3-0.4-0.5-0.8-0.6-1.3c-0.1-0.5-0.2-1.1-0.2-1.7V9.2h2.5v4.6c0,0.8,0.1,1.4,0.3,1.8 c0.2,0.4,0.6,0.5,1.2,0.5c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.5-0.1V9.2h2.5V17.7z"></path></svg>
    </div>

    <div class="login-box-body">
      <form class="form-fixed-help"
          [formGroup]="form"
          (ngSubmit)="submit()"
          [ngClass]="passwordForm ? 'hidden' : ''"
          novalidate>

        <div class="form-group"
            [ngClass]="{ 'has-error': !form.controls._id.valid && form.controls._id.touched }">
          <label>{{ 'USER.ID' | translate }}</label>
          <input type="text"
              class="form-control"
              formControlName="_id">
          <span class="help-block">
            <span *ngIf="form.controls._id.hasError('required')">{{ 'CLIENTERROR.CERR-00001' | translate }}</span>
          </span>
        </div>

        <div class="form-group"
            [ngClass]="{ 'has-error': !form.controls.password.valid && form.controls.password.touched }">
          <label>{{ 'AUTH.PASSWORD' | translate }}</label>
          <input type="password"
              name="password"
              class="form-control"
              formControlName="password">
            <span class="help-block">
              <span *ngIf="form.controls.password.hasError('minlength')">{{ 'CLIENTERROR.CERR-00002' | translate }}</span>
              <span *ngIf="form.controls.password.hasError('required')">{{ 'CLIENTERROR.CERR-00001' | translate }}</span>
            </span>
        </div>

<!--
        <div class="form-group">
          <div class="checkbox">
            <label>
              <input type="checkbox" [checked]="rememberMe" (change)="rememberMe = !rememberMe"> {{ 'AUTH.CHK_REMEMBER' | translate }}
            </label>
          </div>
        </div>
-->

        <div class="form-group">
          <button type="submit"
              class="btn btn-success btn-block btn-flat"
              [disabled]="!form.valid"
              [ladda]="isSubmitting">
            {{ 'AUTH.BTN_LOGIN' | translate }}
          </button>
        </div>

        <!-- <div>
          <a>{{ 'AUTH.FORGOT_PASSWORD' | translate }}</a>
        </div> -->
      </form>

      <form class="form-fixed-help"
          *ngIf="passwordForm"
          [formGroup]="passwordForm"
          (ngSubmit)="submit()"
          novalidate>

        <div class="form-group">
          <span class="text-danger">{{ 'AUTH.FORCE_PASSWORD' | translate }}</span>
        </div>

        <div class="form-group"
            [ngClass]="{ 'has-error': !passwordForm.controls.newPassword.valid && passwordForm.controls.newPassword.touched }">
          <input type="password"
              class="form-control"
              formControlName="newPassword"
              placeholder="{{ 'PROFILE.NEW_PASSWORD' | translate }}">
          <span class="help-block">
            <span *ngIf="passwordForm.controls.newPassword.hasError('required')">{{ 'CLIENTERROR.CERR-00001' | translate }}</span>
            <span *ngIf="passwordForm.controls.newPassword.hasError('minlength')">{{ 'CLIENTERROR.CERR-00002' | translate }}</span>
            <span *ngIf="passwordForm.hasError('matchedFields')">{{ 'CLIENTERROR.CERR-00020' | translate }}</span>
          </span>
        </div>

        <div class="form-group"
            [ngClass]="{ 'has-error': !passwordForm.controls.rePassword.valid && passwordForm.controls.rePassword.touched }">
          <input type="password"
              class="form-control"
              formControlName="rePassword"
              placeholder="{{ 'PROFILE.RETYPE_PASSWORD' | translate }}">
          <span class="help-block">
            <span *ngIf="passwordForm.controls.rePassword.hasError('required')">{{ 'CLIENTERROR.CERR-00001' | translate }}</span>
            <span *ngIf="!passwordForm.controls.rePassword.hasError('required') && !passwordForm.controls.rePassword.valid">{{ 'CLIENTERROR.CERR-00004' | translate }}</span>
            <span *ngIf="passwordForm.hasError('mismatchedFields')">{{ 'CLIENTERROR.CERR-00004' | translate }}</span>
          </span>
        </div>

        <div class="form-group">
          <button type="submit"
              class="btn btn-success btn-block btn-flat"
              [disabled]="!passwordForm.valid"
              [ladda]="isSubmitting">
            {{ 'COMMON.BTN_CONFIRM' | translate }}
          </button>
          <button type="button"
              class="btn btn-default btn-block btn-flat"
              (click)="cancelChangePassword()">
            {{ 'COMMON.BTN_CANCEL' | translate }}
          </button>
        </div>
      </form>

    </div>
  </div>
</body>
